import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertMessageService } from '../services/alert-message.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private alertService: AlertMessageService,
    private translate: TranslateService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(this.handleError.bind(this)));
  }

  handleError(error) {
    const errorMessage: {
      message?: string;
      status?: number;
      detail: string;
      title?: string;
      isServerSide: boolean;
    } = {
      message: '',
      status: 200,
      detail: '',
      title: '',
      isServerSide: true
    };
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage.message = error.error.message;
      errorMessage.isServerSide = false;
    } else {
      // server-side error
      errorMessage.message =
        error.error && error.error.title ? error.error.title : null;
      errorMessage.status = error.status;
      if (error.detail) {
        errorMessage.detail = error.detail;
      }
      if (error.title) {
        errorMessage.title = error.title;
      }
      errorMessage.isServerSide = true;
      if (
        error.error.status === 400 &&
        error.error.message === 'error.validation'
      ) {
        this.alertService.error(
          this.translate.instant('validation.notAllowed')
        );
      }
    }
    return throwError(errorMessage);
  }
}
